const STEPS = [
  ["join the waitlist", "Drop your name, handle and pace. Takes thirty seconds."],
  ["we read every one", "We keep runs small, so we pick a mix of new faces each week."],
  ["see you at the start", "If you're in, we message you the time and meeting spot."],
];

export const Steps = () => (
  <section className="steps" data-testid="how-it-works">
    <h3>how it works</h3>
    <ol>
      {STEPS.map(([title, text], i) => (
        <li key={title} data-testid={`step-${i + 1}`}>
          <b>0{i + 1}</b>
          <strong>{title}</strong>
          <span>{text}</span>
        </li>
      ))}
    </ol>
  </section>
);
